// Prompt do skopiowania i wklejenia do dowolnego AI (ChatGPT/Claude/inne), zeby przygotowac/
// dostosowac wlasne pliki HTML/CSS do dokladnych wymogow importera ZIP (templatepkg.py) - te same
// zasady co w Master Promptcie AI Template Designera (ai_designer.py), zeby oba wejscia (upload ZIP
// i generowanie AI) konwergowaly do tego samego formatu.
export const IMPORT_AI_PROMPT = [
  '## Co to jest i do czego służy (przeczytaj przed resztą)',
  'Ten system SKŁADA dokumenty do eksportu — PDF (ebook/raport/ulotka) albo prezentację (slajdy) — z',
  'reużywalnych fragmentów HTML wypełnianych automatycznie różną, przyszłą treścią. To NIE jest strona',
  'WWW i nie będzie oglądane w przeglądarce przez użytkownika końcowego — każda strona/slajd to',
  'JEDEN NIERUCHOMY, STAŁY KADR o ustalonym z góry rozmiarze, renderowany raz do PDF/obrazu.',
  '',
  'Obsługiwane rozmiary strony/slajdu (fizyczne piksele renderu): A4 794×1123 (portrait) lub 1123×794',
  '(landscape), albo slajd prezentacji 16:9 — 1280×720 (landscape, typowe) lub 720×1280 (portrait).',
  'Nie projektuj pod żaden inny rozmiar.',
  '',
  'Dlatego w HTML/CSS, które przygotujesz, NIE MOŻE być:',
  '- media query / breakpointów reagujących na szerokość okna (`@media (max-width: ...)` itp.) —',
  '  rozmiar kadru jest stały i znany z góry, nie ma "responsywności".',
  '- stanów hover / niczego "ujawnianego po najechaniu" — statyczny render nie ma kursora ani interakcji.',
  '- znacznika `<meta name="viewport">` — nie dotyczy eksportu drukowanego/slajdu.',
  '- założeń o nieskończonym scrollu / lazy-loadingu — cała treść musi być obecna i policzalna w',
  '  jednym, skończonym renderze.',
  '- menu nawigacyjnych, hamburger-menu ani linków "do innej podstrony" — to jeden kadr, nie serwis WWW.',
  '- żadnego JavaScriptu poza tym, co narzędzia edycji sekcyjnej same wstrzykują — Zero <script>/',
  '  <object>/<embed>, zero zależności od CDN/internetu (fonty lokalne/systemowe, nie Google Fonts link).',
  '',
  'Poniżej masz DOKŁADNE wymagania formatu, w który muszą się zmieścić finalne pliki (trafią do',
  'automatycznego importera ZIP, więc struktura i atrybuty muszą być dosłowne, nie w przybliżeniu).',
  '',
  '## Struktura paczki (dokładnie te nazwy katalogów, bez modyfikacji)',
  'Szablon może zawierać jeden, dwa albo trzy warianty tego samego layoutu. Jeśli wariantów jest',
  'więcej niż jeden, najwyższym poziomem paczki są katalogi:',
  'single_page_pdf/      <- PDF jednostronicowy',
  'multipage_pdf/        <- PDF wielostronicowy',
  'presentation/         <- prezentacja PPTX/PDF',
  'a dopiero WEWNĄTRZ każdego z nich znajduje się poniższa struktura. Przy jednym wariancie można',
  'zachować dotychczasową strukturę bez katalogu wariantu (system przyjmie multipage_pdf).',
  '',
  'templates/            <- pełne strony/slajdy (każdy plik = jeden layout strony)',
  'partials_templates/   <- fragmenty wielokrotnego użytku (nagłówek, stopka, numeracja...)',
  'css/                  <- pliki CSS (np. css/main.css)',
  'prompts.json          <- OPCJONALNY plik z gotowymi promptami/podpowiedziami (patrz sekcja niżej)',
  'dowolny inny katalog  <- obrazy/zasoby statyczne (logo, tła) - pliki nie-HTML/CSS są kopiowane 1:1',
  '',
  'KRYTYCZNY KONTRAKT WARIANTÓW: suma nazw data-content w KAŻDYM wariancie musi być identyczna 1:1.',
  'Slot może być w innym miejscu, mieć inny tag i odmienny wygląd, ale zachowuje tę samą semantyczną',
  'nazwę i przeznaczenie. Import zostanie odrzucony z listą brakujących/dodatkowych slotów, jeśli',
  'zestawy się różnią. prompts.json jest wspólny i opisuje wspólne slugi tylko raz.',
  '',
  '## Nazwa pliku = identyfikator layoutu ("slug")',
  'Nazwa pliku bez rozszerzenia staje się identyfikatorem layoutu, np. templates/okladka.html ->',
  'layout "okladka". Używaj małych liter i myślników, bez spacji/polskich znaków, np.',
  'tytul-tresc.html, lista-punktow.html, cytat.html, podsumowanie.html.',
  '',
  'Fragmenty z partials_templates/, które mają pojawiać się na KAŻDEJ stronie (nagłówek, stopka,',
  'numeracja), muszą mieć nazwę zaczynającą się od "global_", np. partials_templates/global_stopka.html.',
  '',
  '## Alternatywny tryb: "sekcyjny" (ebook/prezentacja z rozdziałami złożonymi z sekcji)',
  'Zapytaj mnie, czy budujemy tryb "jednostronicowy" (domyślny, opisany wyżej — jeden plik = jedna',
  'cała strona) czy "sekcyjny", zanim zaczniesz. W trybie sekcyjnym:',
  '- Plik w templates/ to CAŁY ROZDZIAŁ (nie jedna strona!) — może rozlać się na tyle fizycznych',
  '  stron, ile potrzeba. MUSI zawierać jeden wyróżniony kontener: <div data-sections-area></div>',
  '  (system wstawia tam automatycznie dobrane sekcje, owinięte we flex — nie dodawaj tam nic na sztywno).',
  '- Pliki w partials_templates/ (poza global_header*/global_footer*) to SEKCJE — samodzielne,',
  '  reużywalne fragmenty z własnymi slotami data-content, które system dobiera NIEZALEŻNIE do',
  '  każdego rozdziału na podstawie pasujących slotów i opisu użycia (patrz prompts.json niżej).',
  '- Nie projektuj CSS dla stackowania sekcji na stronie (top-align, ostatnia wypełnia resztę',
  '  wysokości) — to robi system automatycznie. Projektuj tylko WNĘTRZE każdej sekcji.',
  '',
  '## Sloty treści dynamicznej - atrybut data-content',
  'Każdy element, którego treść ma być wypełniana automatycznie, MUSI mieć atrybut, np.:',
  '<h1 data-content="tytul-rozdzialu">...</h1>',
  '',
  'Zasady:',
  '- Nazwa slotu: małe litery, myślniki, bez spacji/polskich znaków, SEMANTYCZNA (np. "problem-opis",',
  '  "wniosek-glowny") - NIGDY pozycyjna (np. "left-text", "box-1", "kolumna-2").',
  '- Bez duplikatów data-content w obrębie jednego pliku.',
  '- Elementy czysto dekoracyjne (linie, tła, ikony ozdobne) NIE dostają data-content.',
  '- Zostaw sloty PUSTE w finalnym HTML - żadnej treści demo/placeholder wpisanej na stałe.',
  '- Dla materiałów rozdziałowych preferuj wspólny słownik: tag-1/tag-2/tag-3, chapter-pretitle,',
  '  chapter-title, problem-description, problem-question, procedure-text, procedure-list,',
  '  flowchart-title, flowchart, protip-content, protip-warning, remember-thesis, remember-detail,',
  '  legal-basis. Nie łącz całego rozdziału w jeden slot i nie twórz nazw zależnych od kolumny.',
  '',
  '## Typy treści (content_type) — co wstawia system i jak przygotować HTML wokół data-content',
  'Każdy slot ma docelowo jeden z tych typów (system zgaduje typ z tagu/nazwy przy imporcie, ale',
  'lepiej z góry zaprojektować HTML pod właściwy typ i podać go jawnie w prompts.json):',
  '- text / rich_text — zwykły kontener treści tekstowej (np. <p>, <div>) — system wstawia tekst',
  '  do środka, zostaw pusty.',
  '- title / subtitle — nagłówek (np. <h1>/<h2>), pusty w środku.',
  '- quote — kontener na cytat (np. <blockquote>), pusty.',
  '- bullet_list / numbered_list — system wstawia CAŁĄ gotową listę <ul>/<ol> ze swoimi <li> —',
  '  slot MUSI być pustym kontenerem (np. pusty <div data-content="...">), NIE gotową listą z',
  '  przykładowymi punktami w środku.',
  '- image / generated_image — <img data-content="slug" ...> — system podmienia atrybut src.',
  '  "generated_image" to obraz generowany przez AI na podstawie content_hint (patrz niżej),',
  '  "image" to obraz dostarczony przez użytkownika/import treści.',
  '- table / chart / flowchart — puste kontenery (np. <div data-content="...">), CAŁA zawartość',
  '  (tabela HTML / wykres SVG / diagram) jest wstawiana przez system wewnątrz — nigdy nie buduj',
  '  przykładowej tabeli/wykresu na sztywno w środku.',
  '- link / video — pojedynczy element docelowy (np. <a data-content="...">, <video data-content="...">).',
  '',
  'Dla KAŻDEGO slotu content_hint w prompts.json powinien opisywać OCZEKIWANĄ TREŚĆ, nie znaczniki',
  'HTML — np. dla slotu typu image: "Zdjęcie zespołu przy pracy, naturalne oświetlenie biurowe,',
  'styl reporterski", NIE "kontener <div> z obrazkiem 400x300".',
  '',
  '## Zasady layoutu (bezwzględne, patrz też wstęp o eksporcie drukowanym/slajdach)',
  '- Fizyczna strona ma overflow: hidden. Projektuj z myślą o ZMIENNEJ długości treści',
  '  (krótka/średnia/długa) - nigdy pod jeden konkretny tekst demonstracyjny. Przy nadmiarze treści',
  '  NIE zmniejszaj fontu w CSS - o tym decyduje system (inny layout/paginacja), nie Ty.',
  '- CSS: deterministyczny, Grid/Flexbox/pozycjonowanie absolutne, wspólne tokeny (kolory/fonty/',
  '  odstępy) w :root w css/main.css.',
  '',
  '## Opcjonalnie - wsparcie edytowalnego eksportu do PowerPoint (PPTX)',
  'Jeśli szablon ma też dobrze wyglądać jako EDYTOWALNA prezentacja PowerPoint (nie tylko obrazek',
  'na slajd), dodaj do elementów atrybuty, np.:',
  '<div data-content="tytul" data-pptx-type="text" data-pptx-x="1.0" data-pptx-y="0.5"',
  '     data-pptx-w="8" data-pptx-h="1.2">',
  '- data-pptx-type: text | image | shape | line | chart | table | hyperlink',
  '- data-pptx-x/y/w/h: pozycja i rozmiar W CALACH (inches), od lewego górnego rogu slajdu.',
  'Bez kompletu tych atrybutów dany element eksportuje się jako część zrzutu obrazu całej strony',
  '(nadal działa, tylko nie jest edytowalny w PPTX).',
  '',
  '## Companion-file prompts.json — AUTOMATYCZNIE odczytywany i stosowany przy imporcie',
  'Dołącz do paczki ZIP plik `prompts.json` na najwyższym poziomie (obok templates/, css/ itd.).',
  'To WAŻNA różnica względem "zwykłego opisu": ten plik jest parsowany i stosowany PRZEZ SYSTEM przy',
  'imporcie — WYPEŁNIA pola konfiguratora automatycznie. Nie musisz nic z niego ręcznie przepisywać',
  'w panelu admina po imporcie (możesz oczywiście później doprecyzować/poprawić w konfiguratorze —',
  'to tylko rozsądny punkt startowy, nie ostateczna, zablokowana wartość).',
  '',
  'Wszystkie pola na każdym poziomie są OPCJONALNE — możesz uzupełnić tylko część, albo pominąć',
  'plik całkowicie. Dokładny schemat (slugi "template-1"/"sekcja-a"/"tytul" niżej to placeholdery —',
  'użyj prawdziwych slugów swoich plików/slotów):',
  '```json',
  '{',
  '  "template": {',
  '    "general_assumptions": "Ogólny opis przeznaczenia i tonu całego szablonu (1 akapit)",',
  '    "image_style_prompt": "Styl wizualny generowanych zdjęć AI (1 akapit)",',
  '    "image_color_prompt": "Paleta kolorystyczna generowanych obrazów (1 akapit)"',
  '  },',
  '  "partials": {',
  '    "sekcja-a": {',
  '      "selection_prompt": "Kiedy stosować tę sekcję/layout (WHEN TO USE / PREFERRED CONTENT)",',
  '      "exclusion_prompt": "Kiedy NIE stosować (tylko sekcje w trybie sekcyjnym)",',
  '      "page_break_policy": "splittable",',
  '      "allow_continuation": true,',
  '      "capacity_min_chars": 100,',
  '      "capacity_max_chars": 500,',
  '      "slots": {',
  '        "tytul": {',
  '          "label": "Tytuł sekcji",',
  '          "content_type": "title",',
  '          "content_hint": "Krótki, motywacyjny nagłówek, max 60 znaków",',
  '          "required": true,',
  '          "recommended_length_min": 10,',
  '          "recommended_length_max": 60,',
  '          "behavior_if_empty": "hide_partial"',
  '        }',
  '      }',
  '    }',
  '  }',
  '}',
  '```',
  '- `<partial-slug>` w "partials" MUSI odpowiadać nazwie pliku bez rozszerzenia (np.',
  '  templates/okladka.html -> klucz "okladka"), a `<slot-slug>` MUSI odpowiadać wartości',
  '  atrybutu data-content w tym pliku. Literówka/nieistniejący slug jest po prostu ignorowana',
  '  (nie przerywa importu) — sprawdź listę data-content na końcu tej odpowiedzi przed spakowaniem.',
  '- `page_break_policy`: "atomic" (nie dzielić na strony) albo "splittable" (może się dzielić) —',
  '  dotyczy tylko sekcji w trybie sekcyjnym.',
  '- `behavior_if_empty`: "hide_partial" | "show_empty" | "placeholder".',
  '- `content_type`: jeden z typów z sekcji "Typy treści" wyżej — inna wartość jest ignorowana.',
  '- Błędny/niepoprawny JSON w tym pliku NIE przerywa importu — po prostu żadne pole nie zostanie',
  '  automatycznie wypełnione z tego źródła (poprawisz ręcznie w konfiguratorze).',
  '- Pola szablonu (general_assumptions/image_style_prompt/image_color_prompt) dotyczą tylko trybu',
  '  sekcyjnego i tylko wtedy, gdy odpowiadające pole formularza przy uploadzie zostało puste —',
  '  jeśli ja jako admin coś tam wpiszę ręcznie przy imporcie, to wygrywa nad prompts.json.',
  '',
  '## Co masz mi zwrócić',
  'Dla KAŻDEGO pliku podaj pełną ścieżkę względną i pełną, gotową do zapisania treść, np.:',
  '',
  '### templates/okladka.html',
  '<pełny kod HTML>',
  '',
  '### css/main.css',
  '<pełny kod CSS>',
  '',
  '### prompts.json',
  '<pełna zawartość JSON wg schematu wyżej>',
  '',
  'Na końcu dodaj listę wszystkich użytych data-content pogrupowaną per plik, żebym mógł',
  'zweryfikować kompletność i zgodność ze slugami w prompts.json przed spakowaniem do ZIP-a.',
  '',
  '## Materiały wejściowe (uzupełnij przed wysłaniem)',
  '- Tryb: jednostronicowy (broszura/ulotka) czy sekcyjny (ebook/prezentacja)?',
  '- Warianty w jednej paczce: single_page_pdf / multipage_pdf / presentation (wybierz 1-3): ...',
  '- Nazwa/branding: ...',
  '- Typ dokumentu: ebook / raport / prezentacja / ulotka',
  '- Format strony: A4 (portrait/landscape) / 16:9 (slajd, portrait/landscape)',
  '- Kolory/fonty/styl: ...',
  '- Potrzebne layouty/rozdziały (np. okładka, strona tytułowa, tekst+obraz, lista punktów, cytat,',
  '  tabela, wykres, podsumowanie) — w trybie sekcyjnym: jakie SEKCJE mają się w nich pojawiać: ...',
  '- Istniejące materiały/mockup do przerobienia (wklej kod albo opisz / załącz plik): ...',
].join('\n')
